import styled from "styled-components";
import { ButtonA } from "../../styles-components/Buttons";

export const Company = styled.p`
  font-style: italic;
  margin-bottom: 10px;
  text-align: center;
`;

export const Wrapper = styled.div`
  padding: 0 15px 15px 15px;
  font-size: 1rem;

  ${Company} + div {
    display: flex;
    align-items: center;

    p {
      margin: 0;
    }
  }

  p {
    margin: 0;
    margin-bottom: 5px;
  }

  h3,
  h4 {
    margin: 10px 0;
  }

  h3 {
    text-align: center;
  }

  ${Company} + div {
    display: flex;
    align-items: center;
  }
`;

export const ItemsConfig = styled.div`
  border-top: 1px solid black;

  div + div {
    margin-top: 10px;
  }
`;

export const Actions = styled.div`
  display: block;
  margin-bottom: 5px;

  > {
    display: inline-block;
  }

  ${ButtonA} {
    padding-left: 0;
  }

  ${ButtonA} + ${ButtonA} {
    padding-left: 8px;
  }
`;

export const History = styled.div`
  padding: 2em 1.2em 1em;
  position: relative;
  color: black;
  border-left: ${({ color }) => `2px solid var(${color})`}};

  div{
    margin: 5px 0 0 0;
    padding: 5px 10px;
    border-radius: 3px;
    -webkit-box-shadow: -4px 4px 6px 5px rgba(0,0,0,0.11);
    box-shadow: -4px 4px 6px 5px rgba(0,0,0,0.11);


    h5 {
      font-weight: 500;
      margin: 10px 0;
    }

    p {
      font-size: 0.9rem;
    }
  }

  &::before {
    content: '${({ header }) => header}';
    position: absolute;
    left: 1em;
    font-style: italic;
    color: var(--gray);
    top: 1em;
    display: block;
    font-weight: 700;
    font-size: 0.785rem;
  }

  &::after {
    width: 10px;
    height: 10px;
    display: block;
    top: 1em;
    position: absolute;
    left: -6px;
    border-radius: 10px;
    content: "";
    border: ${({ color }) => `2px solid var(${color})`};
    background: ${({ color }) => `var(${color})`};
  }

  ${Historys}:last-child {
    border-image: ${({ color }) =>
      `linear-gradient(to bottom, var(${color}) 0%, transparent)1 100%`};
  }
`;

export const Historys = styled.div`
  border-top: 1px solid black;
`;
